export const types = {
  LOAD_ORGANIZATIONS: {
    REQUEST: 'LOAD_ORGANIZATIONS.REQUEST',
    SUCCESS: 'LOAD_ORGANIZATIONS.SUCCESS',
    FAILURE: 'LOAD_ORGANIZATIONS.FAILURE',
  },
  UPDATE_ORGANIZATION: {
    STARTED: 'UPDATE_ORGANIZATION.STARTED',
    END: 'UPDATE_ORGANIZATION.END',
    FIELD: 'UPDATE_ORGANIZATION.FIELD',
    ATTENDEE: 'UPDATE_ORGANIZATION.ATTENDEE',
    REQUEST: 'UPDATE_ORGANIZATION.REQUEST',
    SUCCESS: 'UPDATE_ORGANIZATION.SUCCESS',
    FAILURE: 'UPDATE_ORGANIZATION.FAILURE',
  },
  CREATE_ORGANIZATION: {
    WINDOW_OPEN: 'CREATE_ORGANIZATION.WINDOW_OPEN',
    WINDOW_CLOSE: 'CREATE_ORGANIZATION.WINDOW_CLOSE',
    REQUEST: 'CREATE_ORGANIZATION.REQUEST',
    SUCCESS: 'CREATE_ORGANIZATION.SUCCESS',
    FAILURE: 'CREATE_ORGANIZATION.FAILURE',
  },
  LOAD_RULES: {
    REQUEST: 'LOAD_RULES.REQUEST',
    SUCCESS: 'LOAD_RULES.SUCCESS',
    FAILURE: 'LOAD_RULES.FAILURE',
  },
  LOAD_ANALYSTS_LIST: {
    REQUEST: 'LOAD_ANALYSTS_LIST.REQUEST',
    SUCCESS: 'LOAD_ANALYSTS_LIST.SUCCESS',
    FAILURE: 'LOAD_ANALYSTS_LIST.FAILURE',
  },
  FILTER: {
    SET: 'ORGANIZATIONS.FILTER.SET',
    CLEAR: 'ORGANIZATIONS.FILTER.CLEAR',
  },
  CHANGE_PAGE: 'ORGANIZATIONS.CHANGE_PAGE',
  POPULATE_ORGANIZATIONS_LIST: 'POPULATE_ORGANIZATIONS_LIST',
  LOAD_ALL_ORGANIZATIONS: {
    REQUEST: 'LOAD_ALL_ORGANIZATIONS.REQUEST',
  },
  ADD_ATTENDEE: 'ADD_ATTENDEE',
  REMOVE_ATTENDEE: 'REMOVE_ATTENDEE',
};

export const loadOrganozationsRequestAction = (payload) => ({
  type: types.LOAD_ORGANIZATIONS.REQUEST,
  payload,
});
export const loadAllOrganizationsRequestAction = (payload) => ({
  type: types.LOAD_ALL_ORGANIZATIONS.REQUEST,
  payload,
});
export const loadOrganozationsSuccessAction = (payload) => ({
  type: types.LOAD_ORGANIZATIONS.SUCCESS,
  payload,
});
export const loadOrganozationsFailureAction = (payload) => ({
  type: types.LOAD_ORGANIZATIONS.FAILURE,
  payload,
});

export const updateOrganizationFieldAction = (payload) => ({
  type: types.UPDATE_ORGANIZATION.FIELD,
  payload,
});

export const updateOrganizationAttendee = (id, field, value) => ({
  type: types.UPDATE_ORGANIZATION.ATTENDEE,
  id,
  field,
  value,
});

export const updateOrganizationRequestAction = (payload) => ({
  type: types.UPDATE_ORGANIZATION.REQUEST,
  payload,
});
export const updateOrganizationSuccessAction = (payload) => ({
  type: types.UPDATE_ORGANIZATION.SUCCESS,
  payload,
});
export const updateOrganizationFailureAction = (payload) => ({
  type: types.UPDATE_ORGANIZATION.FAILURE,
  payload,
});
export const updateOrganizationStartedAction = (payload) => ({
  type: types.UPDATE_ORGANIZATION.STARTED,
  payload,
});
export const updateOrganizationEndAction = (payload) => ({
  type: types.UPDATE_ORGANIZATION.END,
  payload,
});

export const createOrganizationwindowOpenAction = (payload) => ({
  type: types.CREATE_ORGANIZATION.WINDOW_OPEN,
  payload,
});
export const createOrganizationWinndowCloseAction = (payload) => ({
  type: types.CREATE_ORGANIZATION.WINDOW_CLOSE,
  payload,
});
export const createOrganizationRequestAction = (payload) => ({
  type: types.CREATE_ORGANIZATION.REQUEST,
  payload,
});
export const createOrganizationSuccessAction = (payload) => ({
  type: types.CREATE_ORGANIZATION.SUCCESS,
  payload,
});
export const createOrganizationFailureAction = (payload) => ({
  type: types.CREATE_ORGANIZATION.FAILURE,
  payload,
});

export const loadRulesRequestAction = (payload) => ({
  type: types.LOAD_RULES.REQUEST,
  payload,
});
export const loadRulesSuccessAction = (payload) => ({
  type: types.LOAD_RULES.SUCCESS,
  payload,
});
export const loadRulesFailureAction = (payload) => ({
  type: types.LOAD_RULES.FAILURE,
  payload,
});

export const loadAnalystsListRequestAction = (payload) => ({
  type: types.LOAD_ANALYSTS_LIST.REQUEST,
  payload,
});
export const loadAnalystsListSuccessAction = (payload) => ({
  type: types.LOAD_ANALYSTS_LIST.SUCCESS,
  payload,
});
export const loadAnalystsListFailureAction = (payload) => ({
  type: types.LOAD_ANALYSTS_LIST.FAILURE,
  payload,
});

export const populateOrganizationsWithRules = (organizations) => ({
  type: types.POPULATE_ORGANIZATIONS_LIST,
  organizations,
});

export const setFilterAction = (payload) => ({
  type: types.FILTER.SET,
  payload,
});
export const clearFilterAction = (payload) => ({
  type: types.FILTER.CLEAR,
  payload,
});

export const changePageAction = (payload) => ({
  type: types.CHANGE_PAGE,
  payload,
});

export const addAttendee = () => ({
  type: types.ADD_ATTENDEE,
});

export const removeAttendee = (id) => ({
  type: types.REMOVE_ATTENDEE,
  id,
});



// WEBPACK FOOTER //
// ./redux/actions/organizations.js